import { render } from "./NotificationsComponent.vue?vue&type=template&id=bd995706"
import script from "./NotificationsComponent.vue?vue&type=script&lang=js"
export * from "./NotificationsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__